import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import Avatar from '@components/avatar';
import { BASE_IMG_URL } from '@images/imageUrls';
import classNames from 'classnames';
import { formatTime } from '@utils/timeUtils'; // 相对路径
import InfiniteScrollList from '@components/InfiniteScrollList';
import { Image } from 'antd';
import updateImageListSrc from "@utils/update-image-list-src";
import parse, { domToReact } from 'html-react-parser';
interface PCUserMessageListProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    data: any
    type?: any   // 0是评论，1是@
    likeClick?: Function
    goDetails?: Function
    goTopicDetails?: Function
    goUser?: Function
    searchKeyword?: any // 需要高亮的关键字
    emptyText?: string; // 为空时提示文字
    emptyIcon?: string; // 为空时icon
    emptyBoxStyle?: any; // 为空状态时的自定义样式
}

@inject('app', 'site')
@observer
class PCUserMessageList extends React.Component<PCUserMessageListProps> {
    private emojiMapCache: Map<string, { url: string; category?: string }> | null = null;
    private emojiListStamp: any = null;
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }
    private escapeRegex = (str: string) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    private getEmojiMap = () => {
        const emojiList = this.props.site?.emojiList || [];
        if (this.emojiListStamp === emojiList && this.emojiMapCache) return this.emojiMapCache;

        const map = new Map<string, { url: string; category?: string }>();
        emojiList.forEach((cat: any) => {
            (cat?.emoji || []).forEach((emoji: any) => {
                if (emoji?.code && emoji?.url) {
                    map.set(emoji.code, { url: emoji.url, category: cat?.category });
                }
            });
        });
        this.emojiMapCache = map;
        this.emojiListStamp = emojiList;
        return map;
    };

    private replaceEmojiInContent = (content?: string, useSmall: boolean = false) => {
        if (!content) return content || '';
        const map = this.getEmojiMap();
        if (!map || map.size === 0) return content;
        let result = content;
        map.forEach((info, code) => {
            // useSmall=true 时用小表情（评论区），false时根据category判断（正文）
            const cls = useSmall ? styles.emojiInlineSmall : (info.category === '默认' ? styles.emojiInlineSmall : styles.emojiInlineLarge);
            const imgTag = `<img src="${info.url}" alt="${code}" class="${cls}" />`;
            const reg = new RegExp(this.escapeRegex(code), 'g');
            result = result.replace(reg, imgTag);
        });
        return result;
    };

    // 渲染单个列表项
    renderThreadItem = (item: any, index: number) => {
        const { goDetails,  goUser, type } = this.props;
        // console.log(showRecommendUserList, '是否显示推荐关注列表', recommendUserList)
        let options = {};
        const parserOptions = {
            replace: (domNode: any) => {
                // 可以在这里自定义节点替换逻辑
            },
            ...options
        };
        return (
            <React.Fragment key={item.id || item._id || index}>
                <div className={styles.item} key={item.id || item._id}>
                    <div className={styles.postUserBox}>
                        <div className={styles.postUserLeft}>
                            <Avatar
                                avatarUrl={item.data?.post?.user?.avatar || item.data?.thread?.user?.avatar}
                                titleMark={item.data?.post?.user?.titleMark || item.data?.thread?.user?.titleMark}
                                userCode={item.data?.post?.user?.code || item.data?.thread?.user?.code}
                                size={40}
                                officialSize={16}
                            ></Avatar>
                            <div className={styles.userDetail}>
                                <div
                                    className={styles.userNameBox}
                                    onClick={() => goUser && goUser(item.data?.post?.user || item.data?.thread?.user)}
                                >
                                    <div className={styles.userName}>
                                        {item.data?.post?.user?.nickname || item.data?.thread?.user?.nickname || '普通用户'}
                                    </div>
                                    {(item.data?.user?.titleName || item.data?.thread?.user?.titleName) && (
                                        <div className={styles.titleName}>
                                            {item.data?.post?.user?.titleName || item.data?.thread?.user?.titleName}
                                        </div>
                                    )}
                                </div>
                                {/* 评论内容 */}
                                {/* {type == 0 && <div className={styles.plainText} style={{marginBottom: item?.data?.post?.images?.length > 0 ? '16px' : ''}} onClick={() => goDetails && goDetails(item, true)}>{parse(this.replaceEmojiInContent(item.data?.post?.content, true), parserOptions)}</div>} */}
                                {type == 0 && 
                                    <div 
                                        className={styles.plainText} 
                                        onClick={() => {
                                            const post = item.data?.post;
                                            const thread = item.data?.post?.thread;
                                            
                                            // 判断是否可点击
                                            // 1. post 未被删除 且 已审核通过 (isApproved == 1)
                                            // 2. thread 未被删除 且 已审核通过 (isApproved == 1)
                                            const canClick = 
                                                !post?.deletedAt && post?.isApproved == 1 &&
                                                !thread?.deletedAt && thread?.isApproved == 1;
                                            console.log(canClick, 'canClick')
                                            if (!canClick) return false;
                                            goDetails && goDetails(item, true)
                                        }}
                                    >
                                        {(() => {
                                        if(item.data?.post?.isApproved != 1) {
                                            return '内容审核中';
                                        }
                                        if((!item.data?.post?.isComment && item.data?.post?.deletedAt) || (item.data?.post?.isComment && item.data?.post?.replyPost?.deletedAt)) {
                                            return '评论已被删除';
                                        }
                                        if(item.data?.post?.isComment && item.data?.post?.deletedAt) {
                                            return '回复已被删除';
                                        }
                                        
                                        return parse(this.replaceEmojiInContent(
                                            (item.data?.post?.isComment ? '回复了你：' : '评论了你：') + item.data?.post?.content, 
                                            true
                                        ), parserOptions);
                                        })()}
                                    </div>
                                }
                                {type == 1 && 
                                    <div 
                                        className={styles.plainText} 
                                        onClick={() => {
                                            if(item.data?.thread?.deletedAt) {
                                                return false;
                                            }
                                            if(item.data?.thread?.isApproved != 1) {
                                                return false;
                                            }
                                            goDetails && goDetails(item, true)
                                        }}
                                    >
                                        {(() => {
                                        if(item.data?.thread?.deletedAt) {
                                            return '帖子已被删除';
                                        }
                                        if(item.data?.thread?.isApproved != 1) {
                                            return '内容审核中';
                                        }
                                        return parse(this.replaceEmojiInContent(
                                            '@了你：' + item.data?.thread?.summary, 
                                            true
                                        ), parserOptions);
                                        })()}
                                    </div>
                                    }
                                <div className={styles.postInfo}>
                                    <div>{formatTime(item.createdAt, false)}</div>
                                    {/* {item.data?.post?.source && <>
                                        <div className={styles.gap}></div>
                                        <div>{item.data?.post.source}</div>
                                    </>}
                                    {item.data?.post?.ipRegion && <>
                                        <div className={styles.gap}></div>
                                        <div>{item.data?.post?.ipRegion}</div>
                                    </>} */}
                                </div>
                                
                                {/* 图片 */}
                                {/* {(item?.data?.post?.images?.length > 0 && type == 0) && (
                                    <div className={styles.postImgListBox}>
                                        {item?.data?.post?.images.map((img: any, imgIndex: number) => (
                                            <Image key={img.id || imgIndex} width={110} height={110} style={{borderRadius: '4px', objectFit: 'cover'}} src={updateImageListSrc(img.url, 9)} alt="basic" preview={{ mask: '预览' }} />
                                        ))}
                                    </div>
                                )} */}
                                
                                {/* 帖子详情 */}
                                {/* <div className={styles.postThreadText} onClick={() => goDetails && goDetails(item)}> {type == 0 ? (item.data?.post?.thread?.title || item.data?.post?.thread?.summary) : (item.data?.thread?.title || item.data?.thread?.summary)}</div> */}
                                <div className={styles.postThreadText}>
                                    {/* 评论内容 */}
                                    {item.data?.post?.isComment && 
                                        <div 
                                            className={styles.postContent} 
                                            onClick={() => {
                                                if(item.data?.post?.replyPost?.deletedAt || item.data?.post?.replyPost?.isApproved != 1 || item.data?.post?.thread?.isApproved != 1 || item.data?.thread?.isApproved != 1) {
                                                    return false;
                                                }
                                                goDetails && goDetails(item, true)
                                            }}
                                        >
                                            {(() => {
                                                if(item.data?.post?.replyPost?.deletedAt) {
                                                    return '评论已被删除';
                                                }
                                                if(item.data?.post?.replyPost?.isApproved != 1) {
                                                    return '内容审核中';
                                                }
                                            return parse(this.replaceEmojiInContent(item.data?.post?.replyPost?.content, true), parserOptions);
                                            })()}
                                        </div>
                                    }
                                    {/* 帖子内容 */}
                                    <div 
                                        className={styles.threadContent} 
                                        onClick={() => {
                                            const post = item.data?.post;
                                            const thread = item.type === 0 
                                                ? item.data?.post?.thread 
                                                : item.data?.thread;

                                            // 检查删除状态
                                            if (post?.deletedAt || thread?.deletedAt) return false;

                                            // 检查审核状态
                                            const isPostData = !!post?.id;
                                            const isApproved = isPostData 
                                                ? post?.isApproved == 1 && post?.thread?.isApproved == 1
                                                : thread?.isApproved == 1;

                                            if (!isApproved) return false;
                                            
                                            goDetails && goDetails(item, false);
                                        }} 
                                        style={{
                                            background: !item.data?.post?.isComment ? 'transparent' : '#fff', 
                                            padding: !item.data?.post?.isComment ? '0' : '16px'
                                        }}
                                        >
                                        {(() => {
                                            const isDeleted = item.data?.post?.thread?.deletedAt || item.data?.thread?.deletedAt;
                                            
                                            if (isDeleted) {
                                                return '帖子已被删除';
                                            }
                                            
                                            // 判断对应数据源是否审核通过
                                            if(item.data?.post?.id) {
                                                if(item.data?.post?.thread?.isApproved != 1) {
                                                    return '内容审核中';
                                                }
                                            } else {
                                                if(item.data?.thread?.isApproved != 1) {
                                                    return '内容审核中';
                                                }
                                            }
                                            
                                            return item.data?.post?.id 
                                            ? (item.data?.post?.thread?.title || item.data?.post?.thread?.summary) 
                                            : (item.data?.thread?.title || item.data?.thread?.summary);
                                        })()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    };

    render() {
        const { data, loading = false, hasMore = true, emptyText, emptyIcon, emptyBoxStyle, onLoadMore } = this.props;

        if (!Array.isArray(data)) return null;

        return (
            <div className={styles.listBox}>
                <InfiniteScrollList
                    variant="pc"
                    data={data}
                    loading={loading}
                    hasMore={hasMore}
                    onLoadMore={onLoadMore || (() => { })}
                    renderItem={this.renderThreadItem}
                    threshold={100}
                    emptyText={emptyText || '这里是空的'}
                    emptyIcon={emptyIcon}
                    emptyBoxStyle={emptyBoxStyle}
                    loadingText="加载中..."
                    noMoreText="没有更多帖子了"
                />
            </div>
        );
    }
}

export default PCUserMessageList;